import { Component, OnInit } from '@angular/core';
// import { trigger ,transition,group,query,style,animate } from '@angular/animations';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'pc-nh-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
    })
export class LoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }



}
